module.exports = __webpack_public_path__ + "static/img/lg-ess-img-04@m.ae8d27a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/lg-ess-img-04@m.jpg
// module id = XvX1
// module chunks = 0